import React from "react";
import Marquee from "react-fast-marquee";
import { NavLink } from "react-router-dom";

const marqueeData = [
  {
    title: "RDA Seals Illegal Commercial Properties in Bahria Town Phase-8",
    src: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1747041846/RDA_Seals_Illegal_Commercial_Properties_in_Bahria_Town_Phase-8_yiyll6.pdf",
  },
  {
    title:
      "DG RDA Kinza Murtaza Holds Press Conference to Discuss Future Plans and Development Policies",
    src: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1747041801/DG_RDA_Kinza_Murtaza_Holds_Press_Conference_to_Discuss_Future_Plans_and_Development_Policies_tasgjc.pdf",
  },
  {
    title:
      "RDA Hosts Comprehensive Meeting to Tackle Security Issues in Private Housing Societies",
    src: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1747041800/RDA_Hosts_Comprehensive_Meeting_to_Tackle_Security_Issues_in_Private_Housing_Societies_xpofrd.pdf",
  },
  {
    title: "List of private housing schemes in District Council Rawalpindi",
    src: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1747041799/List_of_private_housing_schemes_in_District_Council_Rawalpindi_yj5qqz.pdf",
  },
  {
    title:
      "Enforcement Squad RDA Dismantles Encroachments Seals Over 50 Properties on Defence Road",
    src: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1747041798/Enforcement_Squad_RDA_Dismantles_Encroachments_Seals_Over_50_Properties_on_Defence_Road_ulnvvo.pdf",
  },
  {
    title:
      "Public Notice Regarding Fake Closed Illegal Housing Schemes in Rawalpindi",
    src: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1747041797/Public_Notice_Regarding_Fake__Closed_Illegal_Housing_Schemes_in_Rawalpindi_wdapzj.pdf",
  },
  {
    title: "List of private housing schemes in RDA controlled area",
    src: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1747041796/List_of_private_housing_schemes_in_RDA_controlled_area_osgl4q.pdf",
  },
  {
    title: "RDA Seals Site Office of University Town Over Rule Violations",
    src: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1747041794/RDA_Seals_Site_Office_of_University_Town_Over_Rule_Violations_l9lss7.pdf",
  },
  {
    title:
      "New Biker Lane Project is expected to be completed very soon DG RDA Kinza Murtaza",
    src: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1747041794/New_Biker_Lane_Project_is_expected_to_be_completed_very_soon_DG_RDA_Kinza_Murtaza_wajxed.pdf",
  },
  {
    title: "RDA Holds Session on Nullah Lai Risks",
    src: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1747041791/RDA_Holds_Session_on_Nullah_Lai_Risks_rfdscn.pdf",
  },
  {
    title:
      "DG RDA Kinza Murtaza Inaugurates Rawal Forest Library at Rawal Forest Park",
    src: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1747041788/DG_RDA_Kinza_Murtaza_Inaugurates_Rawal_Forest_Library_at_Rawal_Forest_Park_ygebtt.pdf",
  },
  {
    title:
      "RDA Takes Strict Action Against Illegal Housing Schemes DG RDA Kinza Murtaza",
    src: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1747041787/RDA_Takes_Strict_Action_Against_Illegal_Housing_Schemes_DG_RDA_Kinza_Murtaza_e0fkiu.pdf",
  },
  {
    title:
      "DG RDA Kinza Murtaza Launches Longest Soan Bridge Girder of Ring Road Rawalpindi Project",
    src: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1747041785/DG_RDA_Kinza_Murtaza_Launches_Longest_Soan_Bridge_Girder_of_Ring_Road_Rawalpindi_Project_nlkrrd.pdf",
  },
  {
    title:
      "RDA's Enforcement Squad Conducts Operations Against 4 Illegal Housing Schemes in Rawalpindi",
    src: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1747041781/RDA_s_Enforcement_Squad_Conducts_Operations_Against_4_Illegal_Housing_Schemes_in_Rawalpindi_xirvbu.pdf",
  },
  {
    title:
      "The Crackdown Against Illegal Housing Societies Will Continue DG RDA Kinza Murtaza",
    src: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1747041778/The_Crackdown_Against_Illegal_Housing_Societies_Will_Continue_DG_RDA_Kinza_Murtaza_v6xm6x.pdf",
  },
  {
    title:
      "DREAMS Project to Harness Improved Water Supply System in Pindi DG RDA Kinza Murtaza",
    src: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1747041775/DREAMS_Project_to_Harness_Improved_Water_Supply_System_in_Pindi_DG_RDA_Kinza_Murtaza_xuydor.pdf",
  },
  {
    title:
      "DG RDA Bans Land Transactions in Agricultural Areas Outside Peri-Urban Limits in Rawalpindi to Preserve Green Belt",
    src: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1747041771/DG_RDA_Bans_Land_Transactions_in_Agricultural_Areas_Outside_Peri-Urban_Limits_in_Rawalpindi_to_Preserve_Green_Belt_bks26f.pdf",
  },
  {
    title:
      "DG RDA Kinza Murtaza Announces New Initiatives for a Cleaner Greener City",
    src: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1747041769/DG_RDA_Kinza_Murtaza_Announces_New_Initiatives_for_a_Cleaner_Greener_City_lvybas.pdf",
  },
  {
    title:
      "Housing Minister Bilal Yasin directs to conduct a public awareness campaign about housing schemes to protect the general public from losses",
    src: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1747041768/Housing_Minister_Bilal_Yasin_directs_to_conduct_a_public_awareness_campaign_about_housing_schemes_to_protect_the_general_public_from_losses_qqpayf.pdf",
  },
  {
    title:
      "Brig R Babar Alauddin Sitara-i-Imtiaz Military Chairperson of Chief Minister Directorate of Evaluation Feedback Inspection and Monitoring DEFIM visits RDA",
    src: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1747041763/Brig_R_Babar_Alauddin_Sitara-i-Imtiaz_Military_Chairperson_of_Chief_Minister_Directorate_of_Evaluation_Feedback_Inspection_and_Monitoring_DEFIM_visits_RDA_obn6au.pdf",
  },
  {
    title:
      "DG RDA Kinza Murtaza Directs Housing Schemes to ensure 100 Compliance of Anti-Dengue SOPs",
    src: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1747041762/DG_RDA_Kinza_Murtaza_Directs_Housing_Schemes_to_ensure_100_Compliance_of_Anti-Dengue_SOPs_jmblas.pdf",
  },
  {
    title:
      "DG RDA Kinza Murtaza Launches Special Public Awareness Campaign 2024 Launch of SMD Truck in Rawalpindi to Inform General Public about Housing Schemes and Dengue Prevention Measures",
    src: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1747041761/DG_RDA_Kinza_Murtaza_Launches_Special_Public_Awareness_Campaign_2024._Launch_of_SMD_Truck_in_Rawalpindi_to_Inform_General_Public_about_Housing_Schemes_and_Dengue_Prevention_Measures_ir9mi3.pdf",
  },
  {
    title:
      "RDA Seals Illegal Under Construction Commercial Building on Old Airport Road Rwp",
    src: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1747041760/RDA_Seals_Illegal_Under_Construction_Commercial_Building_on_Old_Airport_Road_Rwp_l25dyg.pdf",
  },
  {
    title:
      "RDA Issued Notices to Marketing Companies Granna.com and Agency 21 Over Unauthorized Property Expo Advertising",
    src: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1747041757/RDA_Issued_Notices_to_Marketing_Companies_Granna.com_and_Agency_21_Over_Unauthorized_Property_Expo_Advertising_wbf1y6.pdf",
  },
  {
    title:
      "RDA Lodges Fir Against Two Illegal Housing Schemes Namely Mega City Iqbal City and New Metro City",
    src: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1747041756/RDA_Lodges_Fir_Against_Two_Illegal_Housing_Schemes_Namely_Mega_City_Iqbal_City_and_New_Metro_City_wuzoq8.pdf",
  },
  {
    title:
      "Commissioner Rawalpindi Reviews Joint Check Post Arrangements at Old Airport Road in Preparation for SCO Summit",
    src: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1747041756/Commissioner_Rawalpindi_Reviews_Joint_Check_Post_Arrangements_at_Old_Airport_Road_in_Preparation_for_SCO_Summit_qnywje.pdf",
  },
];

const NewsMarque = () => {
  return (
    <div className="relative lg:h-16 md:h-14 h-12 w-full overflow-hidden xl:my-8 lg:my-6 md:my-4 my-2">
      {/* Latest News Label */}
      <div className="absolute left-0 top-0 bottom-0 z-10 bg-[#00643B]">
        <span className="flex justify-center items-center text-white lg:text-[24px] md:text-[20px] text-[16px] font-bold md:px-6 px-4 w-max h-full">
          Latest News
        </span>
      </div>

      {/* Left Fade Effect */}
      <div className="absolute md:left-[160px] left-[120px] top-0 bottom-0 lg:w-40 md:w-24 w-16 bg-gradient-to-r from-[#00643B] to-transparent z-10 pointer-events-none" />

      {/* Marquee Content */}
      <Marquee
        direction="left"
        gradient={false}
        pauseOnHover={true}
        className="text-white bg-[#00643B] font-medium lg:text-[20px] md:text-[16px] text-[13px] h-full pl-[200px] flex items-center lg:gap-12 md:gap-8 gap-4"
      >
        {marqueeData?.map((marquee, i) => (
          <NavLink to={marquee?.src} key={i} target="_blank" className={"pr-6"}>
            {marquee?.title}
          </NavLink>
        ))}
      </Marquee>
    </div>
  );
};

export default NewsMarque;
